import { useContext } from "react";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { generalType } from "../data/general";
import dataArrayHandle from "../function/dataArrayHandle";
import { GeneralContext } from "../provider/general.provider";

const useGeneral = (generalType?: generalType, translate = true) => {
  let { generals } = useContext(GeneralContext);
  const { t } = useTranslation();
  let data: any[] = generals;
  if (generalType && generals) {
    if (translate) {
      data = generals[generalType]?.map((item: any) => ({
        id: item.id,
        name: t(item.name),
      }));
    } else {
      data = generals[generalType];
    }
  }

  if (!data) return { data: [] };

  return { data };
};

export default useGeneral;
